import React from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import clsx from "clsx";
import { User } from "../types";
import useStyle from "../Styles";

interface ConnectedFbProps {
  user: User;
  logout: () => void;
  handleAddMorePages: () => void;
  loading: boolean;
  isCollapsed?: boolean;
}

const ConnectedFb: React.FC<ConnectedFbProps> = ({
  user,
  logout,
  handleAddMorePages,
  loading,
  isCollapsed = false,
}) => {
  const { classes } = useStyle();

  return (
    <Box className={clsx(classes.rootConnectedBox, { collapsed: isCollapsed })}>
      <Avatar
        alt={user?.name || ""}
        src={user?.picture?.data?.url || ""}
        className={clsx(classes.avatar, { collapsed: isCollapsed })}
      />

      <Box sx={{ textAlign: isCollapsed ? "left" : "center", flex: 1 }}>
        <Typography
          variant="h6"
          noWrap
          className={clsx(classes.userName, { collapsed: isCollapsed })}
        >
          {user?.name || "User Account"}
        </Typography>
        {/* {!isCollapsed && (
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: "13px",
              color: "#777",
              mt: 0.5,
            }}
          >
            Connected via Facebook
          </Typography>
        )} */}
      </Box>

      <Box className={classes.actionGroup}>
        <Button
          variant="outlined"
          onClick={logout}
          className={classes.DisconnectButton}
        >
          Disconnect
        </Button>

        <Button
          className={classes.labelAddButton}
          id="user_dropdown"
          disableElevation
          onClick={handleAddMorePages}
          variant="contained"
          startIcon={
            !loading && <AddCircleIcon className={classes.labelAddIcon} />
          }
          endIcon={
            loading && <CircularProgress size={17} sx={{ color: "white" }} />
          }
        >
          {loading ? "Connecting..." : "Add More Pages"}
        </Button>
      </Box>
    </Box>
  );
};

export default ConnectedFb;
